import React from 'react';
import Typography from "@mui/material/Typography";
import {Trans} from "react-i18next";
import UserManager from "../../managers/userManager/userManager";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import {useNavigate} from "react-router";

function EndOfOrder({orderId, error, notFound, cardPaymentURL}) {
    const navigate = useNavigate();

    const retryPayment = () => {
        document.location = cardPaymentURL;
    }

    return (notFound ?
            <Stack spacing={2} useFlexGap>
                <Typography variant="h1">🔍</Typography>
                <Typography variant="h5"><Trans i18nKey={'orderFinalMessage.notFoundTitle'}/></Typography>
                <Typography variant="body1" sx={{color: 'text.secondary'}}>
                    <Trans i18nKey={'orderFinalMessage.notFoundMessage'} values={{orderId: orderId}}/>
                </Typography>
                {UserManager.getUser() ? <Button
                    variant="contained"
                    sx={{alignSelf: 'start', width: {xs: '100%', sm: 'auto'}}}
                    onClick={() => navigate('/user/orders')}
                >
                    <Trans i18nKey={'orderFinalMessage.goToButton'}/>
                </Button> : ''}
            </Stack> :
            (error ?
                <Stack spacing={2} useFlexGap>
                    <Typography variant="h1">⚠️</Typography>
                    <Typography variant="h5">
                        <Trans i18nKey={'orderFinalMessage.errorTitle'}/>
                    </Typography>
                    <Typography variant="body1" sx={{color: 'text.secondary'}}>
                        <Trans i18nKey={'orderFinalMessage.errorMessage'}/>
                    </Typography>
                    {cardPaymentURL ? <Button
                        variant="contained"
                        sx={{alignSelf: 'start', width: {xs: '100%', sm: 'auto'}}}
                        onClick={retryPayment}
                    >
                        <Trans i18nKey={'orderFinalMessage.restartPayment'}/>
                    </Button> : ''}
                </Stack> :
                <Stack spacing={2} useFlexGap>
                    <Typography variant="h1">📦</Typography>
                    <Typography variant="h5"><Trans i18nKey={'orderFinalMessage.thankYou'}/></Typography>
                    <Typography variant="body1" sx={{color: 'text.secondary'}}>
                        <Trans i18nKey={'orderFinalMessage.text'} values={{orderId: orderId}}/>
                    </Typography>
                    {UserManager.getUser() ? <Button
                        variant="contained"
                        sx={{alignSelf: 'start', width: {xs: '100%', sm: 'auto'}}}
                        onClick={() => navigate('/user/orders')}
                    >
                        <Trans i18nKey={'orderFinalMessage.goToButton'}/>
                    </Button> : ''}
                </Stack>)
    );
}

export default EndOfOrder;
